// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max'

/** ==================== 学校管理 ==================== */

export async function fetchErrandSchools(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  keyword?: string
  province?: string
  is_active?: boolean | number
}) {
  return request<API.ErrandApiResponse<API.ErrandListData<API.ErrandSchool>>>('/api/admin/errand/schools', {
    method: 'GET',
    params,
  })
}

export async function fetchErrandSchoolOptions() {
  return request<API.ErrandApiResponse<API.ErrandSchoolOption[]>>('/api/admin/errand/schools/options', {
    method: 'GET',
  })
}

export async function fetchErrandSchoolDetail(id: number) {
  return request<API.ErrandApiResponse<API.ErrandSchool>>(`/api/admin/errand/schools/${id}`, {
    method: 'GET',
  })
}

export async function createErrandSchool(data: API.ErrandSchoolForm) {
  return request<API.ErrandApiResponse<API.ErrandSchool>>('/api/admin/errand/schools', {
    method: 'POST',
    data,
  })
}

export async function updateErrandSchool(id: number, data: Partial<API.ErrandSchoolForm>) {
  return request<API.ErrandApiResponse<API.ErrandSchool>>(`/api/admin/errand/schools/${id}`, {
    method: 'PUT',
    data,
  })
}

export async function toggleErrandSchoolActive(
  id: number,
  data?: {
    is_active?: boolean | number
    force?: boolean | number
  },
) {
  return request<API.ErrandApiResponse<API.ErrandSchool>>(`/api/admin/errand/schools/${id}/active`, {
    method: 'PUT',
    data,
  })
}

export async function fetchRegionProvinces() {
  return request<API.ErrandApiResponse<{ data?: API.ErrandRegionOption[] } | API.ErrandRegionOption[]>>(
    '/api/v1/region/provinces',
    {
      method: 'GET',
    },
  )
}

export async function fetchRegionCities(code: string) {
  return request<API.ErrandApiResponse<{ data?: API.ErrandRegionOption[] } | API.ErrandRegionOption[]>>(
    '/api/v1/region/cities',
    {
      method: 'GET',
      params: {
        code,
        province_code: code,
      },
    },
  )
}

export async function fetchRegionAreas(code: string) {
  return request<API.ErrandApiResponse<{ data?: API.ErrandRegionOption[] } | API.ErrandRegionOption[]>>(
    '/api/v1/region/areas',
    {
      method: 'GET',
      params: {
        code,
        city_code: code,
      },
    },
  )
}

/** ==================== 骑手管理 ==================== */

export async function fetchErrandRiders(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  keyword?: string
  status?: string
  school_id?: number
  is_online?: boolean | number
  start_date?: string
  end_date?: string
}) {
  return request<API.ErrandApiResponse<API.ErrandListData<API.ErrandRider>>>('/api/admin/errand/riders', {
    method: 'GET',
    params,
  })
}

export async function fetchPendingErrandRiders(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
}) {
  return request<API.ErrandApiResponse<{ items: API.ErrandRider[]; total: number }>>('/api/admin/errand/riders/pending', {
    method: 'GET',
    params,
  })
}

export async function fetchErrandRiderDetail(id: number) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}`, {
    method: 'GET',
  })
}

export async function approveErrandRider(id: number) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/approve`, {
    method: 'POST',
  })
}

export async function rejectErrandRider(
  id: number,
  data: {
    reason: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/reject`, {
    method: 'POST',
    data,
  })
}

export async function suspendErrandRider(
  id: number,
  data?: {
    reason?: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/suspend`, {
    method: 'POST',
    data,
  })
}

export async function unsuspendErrandRider(id: number) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/unsuspend`, {
    method: 'POST',
  })
}

export async function banErrandRider(
  id: number,
  data?: {
    reason?: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/ban`, {
    method: 'POST',
    data,
  })
}

export async function unbanErrandRider(id: number) {
  return request<API.ErrandApiResponse<API.ErrandRider>>(`/api/admin/errand/riders/${id}/unban`, {
    method: 'POST',
  })
}

export async function adjustErrandRiderCredit(
  id: number,
  data: {
    delta: number
    reason: string
  },
) {
  return request<
    API.ErrandApiResponse<{
      id: number
      credit_score: number
      delta: number
      reason: string
    }>
  >(`/api/admin/errand/riders/${id}/credit`, {
    method: 'POST',
    data,
  })
}

/** ==================== 合伙人申请 ==================== */

export async function fetchErrandPartners(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  keyword?: string
  status?: string
  school_id?: number
  identity?: string
}) {
  return request<API.ErrandApiResponse<API.ErrandPartnerApplicationListData>>('/api/admin/errand/partners', {
    method: 'GET',
    params,
  })
}

export async function fetchErrandPartnerDetail(id: number) {
  return request<API.ErrandApiResponse<API.ErrandPartnerApplication>>(`/api/admin/errand/partners/${id}`, {
    method: 'GET',
  })
}

export async function approveErrandPartner(id: number) {
  return request<API.ErrandApiResponse<API.ErrandPartnerApplication>>(`/api/admin/errand/partners/${id}/approve`, {
    method: 'POST',
  })
}

export async function rejectErrandPartner(
  id: number,
  data: {
    reason: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandPartnerApplication>>(`/api/admin/errand/partners/${id}/reject`, {
    method: 'POST',
    data,
  })
}

/** ==================== 提现管理 ==================== */

export async function fetchErrandWithdrawals(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  keyword?: string
  status?: string
  withdraw_type?: string
  start_date?: string
  end_date?: string
}) {
  return request<API.ErrandApiResponse<API.ErrandListData<API.ErrandWithdrawal>>>('/api/admin/errand/withdrawals', {
    method: 'GET',
    params,
  })
}

export async function fetchPendingErrandWithdrawals(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
}) {
  return request<API.ErrandApiResponse<API.ErrandListData<API.ErrandWithdrawal> | { items: API.ErrandWithdrawal[]; total: number }>>(
    '/api/admin/errand/withdrawals/pending',
    {
      method: 'GET',
      params,
    },
  )
}

export async function fetchErrandWithdrawalStats() {
  return request<API.ErrandApiResponse<API.ErrandWithdrawalStats>>('/api/admin/errand/withdrawals/stats', {
    method: 'GET',
  })
}

export async function approveErrandWithdrawal(id: number) {
  return request<API.ErrandApiResponse<{ withdrawal: API.ErrandWithdrawal }>>(
    `/api/admin/errand/withdrawals/${id}/approve`,
    {
      method: 'POST',
    },
  )
}

export async function rejectErrandWithdrawal(
  id: number,
  data: {
    reason: string
  },
) {
  return request<API.ErrandApiResponse<{ withdrawal: API.ErrandWithdrawal }>>(
    `/api/admin/errand/withdrawals/${id}/reject`,
    {
      method: 'POST',
      data,
    },
  )
}

/** ==================== 计费配置 ==================== */

export async function fetchErrandPricingConfigs(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  school_id?: number
  config_type?: API.ErrandPricingType | string
  type?: API.ErrandPricingType | string
  is_active?: boolean | number
}) {
  return request<API.ErrandApiResponse<API.ErrandPricingConfig[]>>('/api/admin/errand/pricing', {
    method: 'GET',
    params: {
      ...params,
      config_type: params?.config_type || params?.type,
    },
  })
}

export async function fetchErrandPricingOverview(params?: {
  school_id?: number
}) {
  return request<API.ErrandApiResponse<API.ErrandPricingOverviewGroup[]>>(
    '/api/admin/errand/pricing/overview',
    {
      method: 'GET',
      params,
    },
  )
}

export async function fetchErrandPricingTemplates() {
  return request<API.ErrandApiResponse<API.ErrandPricingTemplatePayload>>(
    '/api/admin/errand/pricing/templates',
    {
      method: 'GET',
    },
  )
}

export async function fetchErrandSystemConfig() {
  return request<API.ErrandApiResponse<API.ErrandSystemConfig>>(
    '/api/admin/errand/configs/system',
    {
      method: 'GET',
    },
  )
}

export async function simulateErrandPricing(data: Record<string, any>) {
  return request<API.ErrandApiResponse<API.ErrandPricingSimulation>>('/api/admin/errand/pricing/simulate', {
    method: 'POST',
    data,
  })
}

export async function copyErrandPricingToSchool(data: {
  school_id: number
  config_types: Array<API.ErrandPricingType | string>
}) {
  return request<API.ErrandApiResponse<{ copied_count?: number; skipped_types?: string[] }>>(
    '/api/admin/errand/pricing/copy-to-school',
    {
      method: 'POST',
      data,
    },
  )
}

export async function createErrandPricing(data: Partial<API.ErrandPricingConfig>) {
  return request<API.ErrandApiResponse<API.ErrandPricingConfig>>('/api/admin/errand/pricing', {
    method: 'POST',
    data,
  })
}

export async function fetchErrandPricingDetail(id: number) {
  return request<API.ErrandApiResponse<API.ErrandPricingConfig>>(`/api/admin/errand/pricing/${id}`, {
    method: 'GET',
  })
}

export async function updateErrandPricing(id: number, data: Partial<API.ErrandPricingConfig>) {
  return request<API.ErrandApiResponse<API.ErrandPricingConfig>>(`/api/admin/errand/pricing/${id}`, {
    method: 'PUT',
    data,
  })
}

export async function toggleErrandPricingActive(id: number) {
  return request<API.ErrandApiResponse<{ id: number; is_active: boolean }>>(
    `/api/admin/errand/pricing/${id}/toggle-active`,
    {
      method: 'POST',
    },
  )
}

/** ==================== 订单管理 ==================== */

export async function fetchErrandOrders(params?: {
  current?: number
  page?: number
  pageSize?: number
  per_page?: number
  keyword?: string
  status?: string
  settlement_status?: string
  school_id?: number
  service_type?: string
  service_level?: string
  pay_method?: string
  start_date?: string
  end_date?: string
  min_amount?: number
  max_amount?: number
  sort_field?: string
  sort_order?: 'asc' | 'desc' | string
}) {
  return request<API.ErrandApiResponse<API.ErrandListData<API.ErrandOrder>>>('/api/admin/errand/orders', {
    method: 'GET',
    params,
  })
}

export async function fetchErrandOrderStats(params?: {
  start_date?: string
  end_date?: string
}) {
  return request<API.ErrandApiResponse<API.ErrandOrderStats>>('/api/admin/errand/orders/stats', {
    method: 'GET',
    params,
  })
}

export async function exportErrandOrders(params?: {
  keyword?: string
  status?: string
  settlement_status?: string
  school_id?: number
  service_type?: string
  service_level?: string
  pay_method?: string
  start_date?: string
  end_date?: string
  min_amount?: number
  max_amount?: number
  limit?: number
}) {
  return request<API.ErrandApiResponse<{ data: Array<Record<string, any>>; total: number }>>(
    '/api/admin/errand/orders/export',
    {
      method: 'GET',
      params,
    },
  )
}

export async function batchSettleErrandOrders(data: {
  order_ids?: number[]
  settle_all?: boolean
}) {
  return request<API.ErrandApiResponse<API.ErrandBatchSettleResult>>(
    '/api/admin/errand/orders/batch-settle',
    {
      method: 'POST',
      data,
    },
  )
}

export async function fetchErrandOrderDetail(id: number) {
  return request<API.ErrandApiResponse<API.ErrandOrder>>(`/api/admin/errand/orders/${id}`, {
    method: 'GET',
  })
}

export async function adjustErrandOrderSettlement(
  id: number,
  data: {
    rider_income: number
    remark: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandOrderSettlementAdjustResult>>(
    `/api/admin/errand/orders/${id}/adjust-settlement`,
    {
      method: 'POST',
      data,
    },
  )
}

export async function settleErrandOrder(id: number) {
  return request<API.ErrandApiResponse<API.ErrandOrderSettleResult>>(`/api/admin/errand/orders/${id}/settle`, {
    method: 'POST',
  })
}

export async function cancelErrandOrder(
  id: number,
  data: {
    reason: string
  },
) {
  return request<API.ErrandApiResponse<API.ErrandOrder>>(`/api/admin/errand/orders/${id}/cancel`, {
    method: 'POST',
    data,
  })
}
